/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Represents Overwolf game mapping information.
 * @export
 * @interface OWGameEventMap
 */
export interface OWGameEventMap {
    /**
     * 
     * @type {string}
     * @memberof OWGameEventMap
     */
    gameId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof OWGameEventMap
     */
    mappings: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof OWGameEventMap
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof OWGameEventMap
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof OWGameEventMap
     */
    updatedAt: number;
}

/**
 * Check if a given object implements the OWGameEventMap interface.
 */
export function instanceOfOWGameEventMap(value: object): value is OWGameEventMap {
    if (!('gameId' in value) || value['gameId'] === undefined) return false;
    if (!('mappings' in value) || value['mappings'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function OWGameEventMapFromJSON(json: any): OWGameEventMap {
    return OWGameEventMapFromJSONTyped(json, false);
}

export function OWGameEventMapFromJSONTyped(json: any, ignoreDiscriminator: boolean): OWGameEventMap {
    if (json == null) {
        return json;
    }
    return {
        
        'gameId': json['gameId'],
        'mappings': json['mappings'],
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
    };
}

export function OWGameEventMapToJSON(json: any): OWGameEventMap {
    return OWGameEventMapToJSONTyped(json, false);
}

export function OWGameEventMapToJSONTyped(value?: OWGameEventMap | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'gameId': value['gameId'],
        'mappings': value['mappings'],
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
    };
}

